import * as angular from 'angular'

angular.module('webtrader').config(($stateProvider, $locationProvider, $urlRouterProvider) => {
  $locationProvider.html5Mode(true)
  $urlRouterProvider.otherwise("/login")

  $stateProvider
  .state('login', {
    url: "/login?account",
    templateUrl: BASE_URL+"templates/page.login.html",
    controller: 'LoginPage',
    resolve: {
      fastLoginAccounts: (Account) => Account.fastLogin()
    }
  })
  .state('token', {
    url: "/token?auth_key",
    templateUrl: BASE_URL+"templates/page.login.html",
    controller: 'LoginPage'
  })
  .state('app', {
    url: "/:accountId",
    templateUrl: BASE_URL+"templates/page.app.html",
    controller: 'AppPage',
    resolve: {
      accountLoaded: ($stateParams, $state, $q, Account) => {
        return Account.init($stateParams.accountId).catch(() => {
          $state.go('login')
          return $q.reject()
        })
      },
      feedLoaded: (accountLoaded, Feed) => Feed.init(),
      init: (feedLoaded, Account, Quotes, Trades) => {
        Quotes.init()
        if (!Account.isGuest)
          return Trades.init()
      }
    },
    onExit: (Feed, Quotes, Trades) => {
      Feed.deinit()
      Quotes.deinit()
      Trades.deinit()
    }
  })
});
